module.exports = __webpack_public_path__ + "static/media/screenshot.5d74078d.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/screenshot.png
// module id = 400
// module chunks = 0